{
  "Baslik": "Elementary Insurance",
  "elementer": {
    "Baslik": "Elementary Insurance",
    "Yeni Ekle": "Add Elementary Insurance",
    "Ekle": "Add",
    "Düzenle": "Edit Elementary Insurance",
    "Genel Bilgiler": "General Information",
    "Dosyalar": "Files",
    "Müşteri": "Customer",
    "Sigorta Türü": "Insurance Type",
    "Başlangıç Tarihi": "Start Date",
    "Bitiş Tarihi": "End Date",
    "Sigorta Şirketi": "Insurance Company",
    "Şirket adı seçin veya yazın...": "Select or type company name...",
    "Poliçe No": "Policy No",
    "Poliçe numarası": "Policy number",
    "Tutar": "Amount (₺)",
    "UAVT Kodu": "UAVT Code",
    "Adres Kodu": "Address Code",
    "Araç Marka Model": "Vehicle Make Model",
    "Örn: 34 ABC 123 - Ford Focus": "e.g. 34 ABC 123 - Ford Focus",
    "Daini Mürtehin": "Daini Murtehin",
    "Banka / Finans kurumu yazın...": "Type bank / financial institution...",
    "Adres": "Address",
    "Açık Adres Bilgisi": "Full Address Information",
    "Gidiş Amacı": "Purpose of Travel",
    "Örn: Turistik / İş Gezisi": "e.g. Tourism / Business Trip",
    "Ülke": "Country",
    "Örn: Almanya, Fransa": "e.g. Germany, France",
    "Açıklama": "Description",
    "Ek notlar ve açıklamalar...": "Additional notes and descriptions...",
    "Takip": "Follow Up",
    "Takip Ediliyor": "Following",
    "Takip Edilmiyor": "Not Following",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Kalan Gün": "Remaining Days",
    "Gün": "Days",
    "Gün Geçti": "Days Overdue",
    "Gün Kaldı": "Days Left",
    "Bugün Bitiyor": "Expires Today",
    "Süresi Doldu": "Expired",
    "Kopyasını Oluştur": "Create Copy",
    "Dosya Seç": "Select File (Photo / PDF)",
    "Dosya Seç (Çoklu seçebilirsiniz)": "Select File (Multiple selection allowed)",
    "Yeni Fotoğraf veya PDF Yükle": "Upload New Photo or PDF",
    "Örn: Poliçe örneği, Kimlik fotokopisi vb.": "e.g. Policy copy, ID photocopy etc.",
    "Yüklü Dosyalar Listesi": "Uploaded Files List",
    "Henüz yüklü dosya bulunmuyor": "No files uploaded yet.",
    "Açıklama ekleyin...": "Add description...",
    "Açıklamayı Kaydet": "Save Description",
    "Görüntüle": "View",
    "Poliçe no, şirket, UAVT vb. ara...": "Search policy no, company, UAVT etc...",
    "Takip Listesi": "Elementary Insurance Follow-up List",
    "Tümünü Gör": "View All",
    "Takip Alt Başlık": "Follow-up policies that are expired or expiring within 15 days",
    "Poliçeyi İncele": "Inspect Policy",
    "Tür": "Type",
    "Dosya Açıklaması": "File Description",
    "Tutar 0'dan büyük olmalıdır": "Amount must be greater than 0",
    "Yükle": "Upload",
    "Durum": "Status",
    "İşlem": "Action",
    "Hepsi": "All",
    "Filtrele": "Filter",
    "Filtreleri Temizle": "Clear Filters",
    "Data Yenile": "Refresh Data",
    "Excel": "Excel",
    "Kaydet": "Save",
    "Güncelle": "Update",
    "İptal": "Cancel",
    "Sil": "Delete",
    "Silme Onayı": "Delete Confirmation",
    "Bu kaydı silmek istediğinize emin misiniz?": "Are you sure you want to delete this record?",
    "Kayıt silindi": "Record deleted",
    "İşlem başarısız": "Operation failed",
    "Veriler yüklenemedi": "Data could not be loaded",
    "Dask": "DASK",
    "Kasko": "Comprehensive Car Insurance",
    "Trafik": "Traffic Insurance",
    "Konut": "Home Insurance",
    "İş Yeri": "Workplace Insurance",
    "Seyahat": "Travel Insurance",
    "Tamamlayıcı Sağlık": "Supplementary Health Insurance",
    "Özel Sağlık": "Private Health Insurance"
  }
}
